import React from 'react';
import './Container.sass';

export const Container = ({children, className = ''}) => (
  <div id="create-container" className={`create-container ${className}`}>
    {children}
  </div>
);
